// Plik: frontend/src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

// Tworzenie kontekstu
const AuthContext = createContext(null);

// Dostawca kontekstu
export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Sprawdź sesję przy ładowaniu
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Wysyłamy żądanie do chronionej trasy, aby sprawdzić, czy sesja jest aktywna
        const response = await api.get('/admin/slots');
        if (response.status === 200) {
          setIsAuthenticated(true);
          // Ponieważ nie przechowujemy informacji o adminie w odpowiedzi, ustawimy tylko flagę
        }
      } catch (error) {
        // Jeśli błąd 401, to nie jesteśmy uwierzytelnieni
        setIsAuthenticated(false);
        setAdmin(null);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  // Funkcja logowania
  const login = async (username, password) => {
    try {
      const response = await api.post('/admin/login', { username, password });
      setAdmin(response.data.admin);
      setIsAuthenticated(true);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.error || 'Błąd podczas logowania'
      };
    }
  };

  // Funkcja wylogowania
  const logout = async () => {
    try {
      await api.get('/admin/logout');
    } catch (error) {
      console.error('Błąd podczas wylogowywania:', error);
    } finally {
      setAdmin(null);
      setIsAuthenticated(false);
    }
  };

  // Wartości udostępniane przez kontekst
  const value = {
    admin,
    isAuthenticated,
    loading,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook do korzystania z kontekstu
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth musi być używany wewnątrz AuthProvider');
  }
  return context;
};